import React, { FC } from "react";
import { Props } from "./types";
import * as S from "./styles";

const EssentialsPlanCard: FC<Props> = ({ handleGoToPayments, price }) => {
  return (
    <S.PricingCard>
      <S.PricingCardHeader>
        <S.PricingBadge>
          <S.PricingBadgeText>GET STARTED</S.PricingBadgeText>
        </S.PricingBadge>
        <S.PricingCardTitle>CareerFit Essentials</S.PricingCardTitle>
      </S.PricingCardHeader>
      <S.PricingCardBody>
        <S.PriceSection>
          <S.PriceWrapper>
            <S.PriceAmount>{price}</S.PriceAmount>
            <S.PriceCurrency>€</S.PriceCurrency>
          </S.PriceWrapper>
          <S.CheckItem>
            <S.CheckIcon>
              <svg
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z"
                  fill="#f6921e"
                />
              </svg>
            </S.CheckIcon>
            <S.CheckText>One-time payment</S.CheckText>
          </S.CheckItem>
        </S.PriceSection>
        <S.PricingDescription>
          Full Personalised CareerFit Report
        </S.PricingDescription>
        <S.IncludedSection>
          <S.IncludedTitle>What&rsquo;s included</S.IncludedTitle>
          <S.IncludedItem>
            <S.IncludedBullet />
            <S.IncludedText>
              Personalised shortlist of up to 16 IDEAL Careers for you
            </S.IncludedText>
          </S.IncludedItem>
          <S.IncludedItem>
            <S.IncludedBullet />
            <S.IncludedText>
              Verbal, Numerical & Abstract Reasoning Assessments
            </S.IncludedText>
          </S.IncludedItem>
          <S.IncludedItem>
            <S.IncludedBullet />
            <S.IncludedText>
              Personalised shortlist of up to 16 IDEAL Careers for you
            </S.IncludedText>
          </S.IncludedItem>
          <S.IncludedItem>
            <S.IncludedBullet />
            <S.IncludedText>
              Interactive Dashboard to explore each recommended career in detail
            </S.IncludedText>
          </S.IncludedItem>
        </S.IncludedSection>
      </S.PricingCardBody>
      <S.PricingCardFooter>
        <S.PricingButton onClick={() => handleGoToPayments("essentials")}>
          Start Now
        </S.PricingButton>
      </S.PricingCardFooter>
    </S.PricingCard>
  );
};

export default EssentialsPlanCard;
